import { IntegrationConfigRenderBase } from './integrationConfigRenderBase'

export class DeskeraConfigRender extends IntegrationConfigRenderBase {
  protected showContactsCount = false

  protected getContacts(communitySystemId: number, selectedFilterId: string, selectedFilterName: string) {
    // not supported
  }
}
